import { render, staticRenderFns } from "./UploadSpinner.vue?vue&type=template&id=2090e2b8&scoped=true&"
import script from "./UploadSpinner.vue?vue&type=script&lang=js&"
export * from "./UploadSpinner.vue?vue&type=script&lang=js&"
import style0 from "./UploadSpinner.vue?vue&type=style&index=0&id=2090e2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090e2b8",
  null
  
)

export default component.exports